import React from "react";
import { Tag } from "antd";
import { RFQStatus } from "../../util/Constant";

const statusDetails = {
  [RFQStatus.DRAFT]: {
    label: "Draft",
    color: "black",
  },
  [RFQStatus.PENDING_APPROVAL]: {
    label: "Pending Approval",
    color: "#A3A3AD",
  },
  [RFQStatus.PUBLISHED]: {
    label: "Published",
    color: "#40507E",
  },
  [RFQStatus.QUOTATION_RECEIVED]: {
    label: "Quotation Received",
    color: "#F5993F",
  },
  [RFQStatus.QUOTATION_SENT]: {
    label: "New Quotation",
    color: "#F5993F",
  },
  [RFQStatus.ORDER_PLACED]: {
    label: "Order Placed",
    color: "#40507E",
  },
  [RFQStatus.ORDER_CONFIRMED]: {
    label: "Order Confirmed",
    color: "#2FB07E",
  },
    [RFQStatus.APPROVED]: {
    label: "Approved",
    color: "#096c46",
  },
  [RFQStatus.REJECTED]: {
    label: "Rejected",
    color: "#FF0000",
  },
  [RFQStatus.AWAITING_FOR_QUOTATION]: {
    label: "Awaiting For Quotation",
    color: "#9d9d9d",
  },
  [RFQStatus.NEGOTIATE]: {
    label: "Negotiate",
    color: "#ff9800",
  },
  [RFQStatus.BLOCK_THE_RATE]: {
    label: "Block the Rate",
    color: "#2FB07E",
  },
  [RFQStatus.SUBMITTED]: {
    label: "Submitted",
    color: "#ff9800",
  },
  [RFQStatus.CONFIRMED]: {
    label: "Confirmed",
    color: "#2FB07E",
  },
    [RFQStatus.OFFER_REJECTED]: {
    label: "Rejected",
    color: "#FF0000",
  },
};

const RFQStatusTags = ({ status }) => {
  return (
    <div>
      <Tag color={statusDetails[status]?.color}>
        {statusDetails[status]?.label}
      </Tag>
    </div>
  );
};

export default RFQStatusTags;
